import { Map } from 'react-loadable'

export const prefetch = () =>
  import('./components')

const AboutMeModule = Map({
  loader: {
    Module: prefetch
  },
  loading: () => null,
  render: ({ Module }, props) => {
    const Component = Module.default
    return <Component {...props} />
  }
})

export const AboutMe = AboutMeModule
